"use client";

import { MarkdownContent } from "@/components/cms/MarkdownContent";
import type { PageDetail } from "@/lib/pages-api";

export interface PageRendererProps {
  page: PageDetail;
}

export function PageRenderer({ page }: PageRendererProps) {
  return (
    <div
      data-testid="cms-page-content"
      className="mx-auto max-w-3xl px-4 py-8 sm:py-12"
    >
      <h1 className="text-ink-900 text-2xl font-semibold tracking-tight sm:text-3xl">
        {page.title}
      </h1>
      <MarkdownContent
        content={page.body}
        className="mt-6"
        testId="cms-page-body"
      />
    </div>
  );
}
